export default __webpack_public_path__ + "static/media/support.e878f2d7.svg";